import {initializeApp} from 'firebase/app';

// @ts-ignore
import firebaseConfig from '../../firebaseConfig.js';

const FirebaseApp = initializeApp(firebaseConfig);

export {FirebaseApp};
